import Swiper, { Navigation, Thumbs, Pagination } from 'swiper';
Swiper.use([Navigation]);
const swiperInit = () => {
    const product_slider = new Swiper(".product-slider", {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 20,
        navigation: {
            nextEl: ".product-slider-next",
            prevEl: ".product-slider-prev",
          },
    });

    const new_product_slider = new Swiper(".new-product-slider", {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 20,
        navigation: {
            nextEl: ".new-product-slider-next",
            prevEl: ".new-product-slider-prev",
          },
    });

    const news_slider = new Swiper(".news-slider", {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 0,
        navigation: {
            nextEl: ".news-slider-next",
            prevEl: ".news-slider-prev",
          },

        breakpoints:{
            1300: {
                slidesPerView: 3,
            }
        },
    });

    // const about_photo_slider = new Swiper('.about_photo_slider', {
    //     modules: [Navigation],
    //     slidesPerView: 4,
    //     spaceBetween: 20,
    //     navigation: {
    //         nextEl: ".photos-slider-next",
    //         prevEl: ".photos-slider-prev"
    //     },
    //     breakpoints: {
    //         500: {
    //             slidesPerView: 1
    //         }
    //     }
    // });
}

export default swiperInit;